module.exports = __webpack_public_path__ + "img/334.e8bfb33c.jpg";